






































// @ is an alias to /src
import { Component, Vue, Watch } from 'vue-property-decorator'
import {AloArbo, getDefaultAloArbo} from '@/models/alo/AloArbo'
import CartItem from '@/components/panier/CartItem.vue'
import EditPlat from '@/components/carte/EditPlat.vue'
import SejourDetail from '@/components/panier/SejourDetail.vue'

import { groupByNumber } from '@/utils/groupBy'
import { ItemPanier } from '@/models/alo/ItemPanier'
import DeliveryPicker from '@/components/shared/DeliveryPicker.vue'
import { AloPanier } from '@/models/alo/AloPanier'
import { AloSejour } from '@/models/alo/AloSejour'

@Component({
  name: 'CartDetail',
  props:{
    panier:{
      type:Object,
      required:true
    },
    sejour:{
      type:Object,
      required:true
    },
    readOnly:{
      type:Boolean,
      default:false
    }    
  },
  components:{
    CartItem,EditPlat,DeliveryPicker,SejourDetail
  }
})
export default class CartDetail extends Vue {
  
  private showEdit = false
  showHoraire = false
  private panier!:AloPanier
  private sejour!:AloSejour
  private readOnly!:Boolean
 
  get nbItems(){
    return this.panier.nbItems
  }

  editItemPanier(item:ItemPanier) {    
    (this.$refs.editPlat as EditPlat).edit(item)
    this.showEdit = true
  }  

  //regroupement du panier par section
  get panierGroup(){
    return groupByNumber(this.panier.items,it => it.sectionId || 0)
  }

  get heureLivraison(){
    return this.panier.heureLivraison
  }  
  set heureLivraison(heure) {
    this.$emit("updateHeureLivraison",heure) 
  }

  get commentaire(){
    return this.panier.commentaire
  }  
  set commentaire(comment) {
    this.$emit("updateCommentaire",comment) 
  }

  get nbCouverts(){
    return this.panier.nbCouverts
  }

  set nbCouverts(nb){
    this.$emit("updateNbCouverts",nb)    
  }

  get platsDic(){    
    return this.$store.myGetters.platsDic
  }

  get canRoomService(){
    return this.$store.myGetters.canRoomService
  }

  updateItemCommentaire (commentaire:string,uuid:string) {         
    this.$emit("updateItemCommentaire",{uuid,commentaire})        
  }

  udpateQty(qty:number,uuid:string){        
    this.$emit("udpateQty",{uuid,qty})          
  }  


  udpateCartItem(item:ItemPanier){
    this.$emit("udpateCartItem",item)    
  }

  minDateCrenaux(){
    return (this.$refs.deliveryPicker as DeliveryPicker).minDateCrenaux()
  }
}
